import { formatReleaseDate } from './releaseDate.js';

interface ReleaseIdentifierProps {
  releasedAt: string;
}

/** A deliberately quiet build marker for confirming which deployment is running. */
export const ReleaseIdentifier = ({ releasedAt }: ReleaseIdentifierProps): React.JSX.Element => (
  <time
    className="release-identifier"
    dateTime={releasedAt}
    title={`UTC build timestamp: ${releasedAt}`}
  >
    Released {formatReleaseDate(releasedAt)}
  </time>
);
